export default function dateFormat(date: Date) {
  return {
    toISO() {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    }
  }
}
